<section class="page-title-area">
  <div class="container">
    <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea;">
      <h2>{{pageTitle.title}}</h2>
      <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{pageTitle.title}}</li>
        <li>{{pageTitle.subTitle}}</li>
      </ul>
    </div>
  </div>

  <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
  <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
  <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="case-studies-details-area">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        <app-gallery-hotel></app-gallery-hotel>
        <div class="case-studies-details-desc">

          <h3>Auditório</h3>
          <p style="text-align: justify;">Ideal para realização de pequenos eventos e reuniões</p>
          <p>
            <strong>Capacidade de até 66 pessoas<br>
              Estrutura de áudio e vídeo<br>
              Banheiros individuais</strong>
          </p>
        </div>
        <div class="case-studies-details-desc">

          <h3>Espaço Home Office</h3>
          <p style="text-align: justify;">Para você trabalhar com a tranquilidade de estar em casa</p>
          <p style="text-align: justify;">
            <strong>- Internet dedicada de alta velocidade, oferecendo a melhor qualidade de conexão inclusive para
              reuniões com vídeo, web aulas e o que mais for preciso.<br>
              - Protegido por Firewall e exclusivo para atividades não recreativas<br>
              - Amplo e aconchegante espaço</strong>
          </p>
        </div>
        <div class="case-studies-details-desc" *ngFor="let DetailsDesc of caseStudiesDetailsDesc;">

          <h3>{{DetailsDesc.title}}</h3>
          <p style="text-align: justify;">{{DetailsDesc.paragraph}}</p>

        </div>
      </div>

    </div>
  </div>
</section>
